module.exports = __webpack_public_path__ + "static/img/no-bg-eat-type-bg.13b595d8.png";